import React, { useState } from 'react'
import { connect } from 'react-redux'
import { useParams } from 'react-router-dom'
import { AzureAD, AuthenticationState } from 'react-aad-msal'
import { TabContent, TabPane, Nav, NavItem, NavLink, Alert } from 'reactstrap'
import classnames from 'classnames'
import { handleDismissSucessAlert } from '../actions/companyActionCreators'
import { handleUpdateAccountStatus, handleBackToCompanies } from '../actions/companyActions'
import PageContainer from '../Shared/LayoutComponents/PageContainer'
import CompanyDetailsTable from './CompanyDetailsTable'
import AuditTrail from './AuditTrail/AuditTrail'
import SyncHistory from './SyncHistory/SyncHistory'
import CompanyUsersTable from './CompanyUsers/CompanyUsersTable'
import useFetchingCompanyDetails from './useFetchingCompanyDetails'
import Settings from './Settings/Settings'
import { useDispatch } from 'react-redux'
import { fetchCompanyDetails } from '../actions/companyActions'
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css'
import 'react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css'
import 'react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min.css'
import { authProvider } from '../../services/authProvider'

import LoadingSpinner from '../Shared/LoadingSpinner'

const CompanyDetails = (props) => {
  const [activeTab, setActiveTab] = useState('1')
  const [page, setPage] = useState(1)
  const [pageSize, setPageSize] = useState(20)
  const [sortField, setSortField] = useState('displayName')
  const [sortOrder, setSortOrder] = useState('asc')

  const dispatch = useDispatch()
  let params = useParams()

  const toggle = (tab) => {
    if (activeTab !== tab) setActiveTab(tab)
  }
  const [visible, setVisible] = useState(true)

  const onDismiss = () => {
    setVisible(false)
    props.handleDismissSucessAlert()
  }

  useFetchingCompanyDetails(params.companyId, page, pageSize, sortField, sortOrder)

  const handleUpdatePage = (newPage, newSizePerPage, newSortField, newSortOrder, filters) => {
    setPage(newPage)
    setPageSize(newSizePerPage)
    setSortField(newSortField)
    setSortOrder(newSortOrder)

    dispatch(fetchCompanyDetails(params.companyId, false, newPage, newSizePerPage, newSortField, newSortOrder, filters))
  }

  if (props.loading) {
    return <LoadingSpinner />
  } else {
    return (
      <AzureAD provider={authProvider}>
        {({ accountInfo }) => {
          let isAdmin = false;
          let isITManager = false;
          if (accountInfo && accountInfo.account && accountInfo.account.idToken && accountInfo.account.idToken.roles) {
            if (accountInfo.account.idToken.roles.includes('Admin')) {
              isAdmin = true
            }
            if (accountInfo.account.idToken.roles.includes('ITManager')) {
              isITManager = true
            }
          }

          return (
            <PageContainer>
              {props.newCompanyLabel && props.newCompanyUserCount && (
                <Alert color="success" isOpen={visible} toggle={onDismiss}>
                  <b>Success</b>
                  <br />
                  Connected to company {props.newCompanyLabel && props.newCompanyLabel.label} in Azure AD.
                  <br />
                  Synchronized {props.newCompanyUserCount} users.
                </Alert>
              )}
              <CompanyDetailsTable />
              <Nav tabs style={{ "padding-top": "15px" }}>
                <NavItem>
                  <NavLink
                    className={classnames({ active: activeTab === '1' })}
                    onClick={() => {
                      toggle('1')
                    }}
                  >
                    Users
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    className={classnames({ active: activeTab === '2' })}
                    onClick={() => {
                      toggle('2')
                    }}
                  >
                    Audit Trail
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    className={classnames({ active: activeTab === '3' })}
                    onClick={() => {
                      toggle('3')
                    }}
                  >
                    Sync History
                  </NavLink>
                </NavItem>
                {(isAdmin || isITManager) && (
                  <NavItem>
                    <NavLink
                      className={classnames({ active: activeTab === '4' })}
                      onClick={() => {
                        toggle('4')
                      }}
                    >
                      Settings
                    </NavLink>
                  </NavItem>
                )}
              </Nav>
              <div>
                <TabContent activeTab={activeTab}>
                  <TabPane tabId="1" style={{ paddingTop: '25px' }}>
                    <CompanyUsersTable
                      location={props.location}
                      page={page}
                      pageSize={pageSize}
                      updatePage={handleUpdatePage}
                    />
                  </TabPane>
                  <TabPane tabId="2" style={{ paddingTop: '25px' }}>
                    {activeTab === '2' && <AuditTrail />}
                  </TabPane>
                  <TabPane tabId="3" style={{ paddingTop: '25px' }}>
                    {activeTab === '3' && <SyncHistory />}
                  </TabPane>
                    <TabPane tabId="4" style={{ paddingTop: '25px' }}>
                      {activeTab === '4' && <Settings isAdmin={isAdmin} />}
                    </TabPane>
                </TabContent>
              </div>
            </PageContainer>
          )
        }}
      </AzureAD>
    )
  }
}

const mapStateToProps = (state) => ({
  loading: state.company.loadingDetails,
  displayedCompanyUsers: state.company.displayedCompanyUsers,
  selectedCompany: state.company.selectedCompany,
  newCompanyLabel: state.company.newCompanyLabel,
  newCompanyUserCount: state.company.newCompanyUserCount,
})

const mapDispatchToProps = {
  handleUpdateAccountStatus,
  handleBackToCompanies,
  handleDismissSucessAlert,
}

export default connect(mapStateToProps, mapDispatchToProps)(CompanyDetails)
